import { restRequest } from "vrcore-dashboard/dist/utilities";

export const SET_PAGE_TYPE = "JOB_PACK_V3.SET_PAGE_TYPE";
export const GET_USER = restRequest("JOB_PACK_V3.GET_USER");
export const GET_CONFIG = restRequest("JOB_PACK_V3.GET_CONFIG");
export const GET_AREAS = restRequest("JOB_PACK_V3.GET_AREAS");
export const GET_DEPARTMENTS = restRequest("JOB_PACK_V3.GET_DEPARTMENTS");
